import React, { useContext, useState } from "react";
import * as S from "./styles";
import logoSin from "../../assets/ATUAL APP - SIN_Sinosserra-branco.svg";
import { toast } from "react-toastify";
import api from "../../services/api";

import Button from "../../components/Button";
import BorderedInputText from "../../components/BorderedInputText";
import Skeleton from "../../components/skeleton";

import { Context } from "../../context/globalContext";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useLocation } from "react-router";
import history from "../../utils/history";

const SendSchema = Yup.object().shape({
  password: Yup.string()
    .required("O campo deve ser preenchido")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
      "A sua senha precisa ter 8 caracteres e pelo menos 1 letra maiúscula, 1 número, 1 caractere especial."
    ),
  passwordRepeat: Yup.string()
    .oneOf([Yup.ref("password")], "As suas senham precisam ser iguais ")
    .required("O campo deve ser preenchido"),
});

export default function PasswordReset() {
  const { setIsLoading } = useContext(Context);
  const globalContext = useContext(Context);
  const [isStrong, setIsStrong] = useState(false);
  const [sent, setSent] = useState(false);
  const params = useQuery();
  const regexPassword = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  );

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const passwordTest = (password) => {
    if (regexPassword.test(password)) {
      setIsStrong(true);
    } else {
      setIsStrong(false);
    }
    return;
  };

  const HandleSubmit = async (values) => {
    setIsLoading(true);
    const payload = {
      senha: values.password,
    };
    try {
      const response = await api.post(
        `api/recuperarSenha/usuario/mudarSenha?token=${params.get("token")}`,
        payload
      );
      if (response && (response.status === 204 || response.status === 200)) {
        toast.success("Senha redefinida com sucesso!");
        setSent(true);
      } else if (!response) {
        toast.error("Erro ao salvar, verifique os dados e tente novamente!");
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao salvar, verifique os dados e tente novamente!");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <S.Wrapper>
      <S.LeftWrapper>
        <div />
        <img src={logoSin} />
      </S.LeftWrapper>

      <S.RightWrapper>
        <div>
          <S.Header>
            <S.TitleBox>
              <div>
                <S.Description>Olá {params.get("nome")}!</S.Description>
              </div>
            </S.TitleBox>
          </S.Header>

          <S.Content>
            {!sent ? (
              <Formik
                initialValues={{ password: "", passwordRepeat: "" }}
                validationSchema={SendSchema}
                onSubmit={async (values) => HandleSubmit(values)}
              >
                {({ errors, touched, values, setFieldValue }) => (
                  <Form>
                    <div className="div-form">
                      {!globalContext.isLoading ? (
                        <BorderedInputText
                          type="password"
                          name="password"
                          label="Nova Senha"
                          icon="true"
                          visState="false"
                          value={values.password}
                          error={errors.password}
                          onChange={(e) => {
                            setFieldValue("password", e.target.value);
                            passwordTest(e.target.value);
                          }}
                        />
                      ) : (
                        <S.SkeletonInput>
                          {" "}
                          <Skeleton type="label" />
                          <Skeleton type="borderedInput" />
                        </S.SkeletonInput>
                      )}
                      {isStrong ? <p>{errors.password}</p> : <></>}
                    </div>
                    <div className="div-form">
                      {!globalContext.isLoading ? (
                        <BorderedInputText
                          type="password"
                          name="passwordRepeat"
                          label="Repitir a nova senha"
                          icon="true"
                          visState="false"
                          value={values.passwordRepeat}
                          error={errors.passwordRepeat}
                          onChange={(e) => {
                            setFieldValue("passwordRepeat", e.target.value);
                          }}
                        />
                      ) : (
                        <S.SkeletonInput>
                          <Skeleton type="label" />
                          <Skeleton type="borderedInput" />
                        </S.SkeletonInput>
                      )}
                    </div>
                    <S.ButtonContainer>
                      <Button type="submit">redefinir senha</Button>
                    </S.ButtonContainer>
                  </Form>
                )}
              </Formik>
            ) : (
              <S.SentBox>
                <div id="SentText">
                  <p>Sua senha foi alterada com sucesso.</p>
                </div>
              </S.SentBox>
            )}
          </S.Content>
        </div>
      </S.RightWrapper>
    </S.Wrapper>
  );
}
